<template>
  <div
    class="produce_jd_qr"
    v-loading="loading"
    element-loading-text="加载中"
    :key="activeName"
  >
    <div v-if="data.length > 0" ref="produce_jd_qr_1" class="con"></div>
    <div v-if="data.length > 0" ref="produce_jd_qr_2" class="con"></div>
    <div v-if="data.length == 0" class="kong">暂无数据</div>
  </div>
</template>

<script>
import { require } from "@/utils/http_request.js";

export default {
  name: "produce_jd_qr",
  props: ["activeName", "show_data"],
  //组件引入
  components: {},
  //状态存储
  data() {
    return {
      loading: true,
      data: [],
    };
  },
  //计算属性
  computed: {},
  //状态监听
  watch: {
    activeName() {
      this.loading = true;
      this.getData();
    },
    show_data() {
      this.loading = true;
      this.getData();
    },
  },
  //存放方法集合
  methods: {
    handleClick() {
      this.getData();
    },
    produce_jd_qr(ele, series_name, x_data, series_data, color) {
      // console.log("produce_jd_qr", this.$refs.produce_jd_qr);
      this.$echarts.init(ele).setOption({
        // title: {
        //   text: "简历总浏览量",
        //   //   left: "center",
        // },
        color: color,

        tooltip: {},
        xAxis: {
          type: "category",
          // boundaryGap: false,
          axisLine: {
            show: false,
          },
          axisLabel: {
            color: "#000", //坐标轴字体颜色 （横向）
            rotate: -90, //字体旋转
          },
          data: x_data,
        },
        yAxis: {
          type: "value",
          axisLine: {
            show: false,
          },
          axisLabel: {
            color: "#000", //坐标轴字体颜色 （横向）
            // rotate: 20, //字体旋转
          },
        },
        series: [
          {
            name: series_name,
            type: "line",
            stack: "总量",
            itemStyle: { normal: { label: { show: true } } },
            backgroundStyle: {
              color: "rgb(50, 199, 245)",
            },
            areaStyle: {},
            emphasis: {
              focus: "series",
            },
            data: series_data,
          },
        ],
      });
    },
    getData() {
      let obj = {
        user_detail_id: this.$route.query.id,
        day_week: this.activeName,
        show_data: this.show_data,
      };
      require("POST", "/hr24_index_data/v1/user_data_detail/", obj).then(
        (res) => {
          if (!res.code) {
            this.loading = false;
            this.data = res.data[0].jd_list;
            let data_1 = res.data[0].jd_list;
            let data_2 = res.data[1].date_list;
            console.log("data1data2", data_1, data_2);
            let x_data_1 = [];
            let x_data_2 = [];
            let serives_data_1 = [];
            let serives_data_2 = [];
            data_1.map((item) => {
              x_data_1.push(item.jd_name);
              serives_data_1.push(item.number);
            });
            data_2.map((item) => {
              x_data_2.push(item.date);
              serives_data_2.push(item.day_count);
            });
            if (data_1.length > 0) {
              this.$nextTick(() => {
                this.produce_jd_qr(
                  this.$refs.produce_jd_qr_1,
                  "分享海报",
                  x_data_1,
                  serives_data_1,
                  ["#079EF9"]
                );
                this.produce_jd_qr(
                  this.$refs.produce_jd_qr_2,
                  "分享海报",
                  x_data_2,
                  serives_data_2,
                  ["#f00f5f"]
                );
              });
            }
          }
        }
      );
    },
  },
  //数据初始化之后
  created() {},
  //页面渲染之后
  mounted() {
    this.getData();
  },
  //数据初始化之前
  beforeCreate() {},
  //页面渲染之前
  beforeMount() {},
  //状态更新之前
  beforeUpdate() {},
  //状态更新之后
  updated() {},
  //页面卸载之前
  beforeDestroy() {},
  //卸载之后
  destroyed() {},
  //页面进入   页面缓存时有效
  activated() {},
};
</script>
<style  scoped>
/* //@import url(); 引入公共css类 */

.produce_jd_qr {
  padding: 60px 20px 20px;
  min-height: 400px;
}

.produce_jd_qr > p {
  float: left;
  width: 150px;
  line-height: 50px;
  text-align: center;
  font-size: 14px;
  color: #fff;
  margin: 0;
  border: #fff solid 2px;
  background: rgb(140, 174, 236);
}
.produce_jd_qr .con {
  width: 50%;
  float: left;
  height: 600px;
}
.produce_jd_qr .kong {
  width: 100%;
  text-align: center;
  font-size: 20px;
  color: #ccc;
  line-height: 400px;
}
</style>


// WEBPACK FOOTER //
// src/components/recruitmentData/produce_jd_qr.vue